"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Component = void 0;
const app_1 = require("app");
class Component {
    constructor() {
        this.skipInitIfNotOnPage = true;
        this.componentHasError = false;
        app_1.ComponentService.AddComponent(this);
    }
    SetPendingUpdate() {
        app_1.ComponentService.AddPendingUpdateComponent(this);
    }
}
exports.Component = Component;
